/**
 * Pure layout decision for the FIGHT move menu — no Phaser, no scene state, so it is
 * unit-tested independently (mirrors menuNav / evolutionChoice). The Battle scene feeds
 * it the live viewport and applies the result to the shared Menu component.
 */
import { FONT, SPACING } from './ui/theme.js';

/** How the FIGHT move menu should lay out for a given viewport. */
export interface MoveMenuLayout {
  readonly columns: number;
  /** Fixed box width (px) for the single-column phone layout; undefined = Menu auto-fit. */
  readonly width?: number;
  /** Smaller font (px) for the narrow phone layout; undefined = Menu default. */
  readonly fontSize?: number;
}

/**
 * Decide the FIGHT move-menu layout from the live viewport. The classic 2×2 grid is the
 * desktop/roomy look, but on a NARROW PORTRAIT phone two columns of long move names
 * ("Thunderbolt   PP 15/15  SUPER") overflow the safe width and the LEFT column runs off
 * the left viewport edge (clipped, untappable). There we fall back to a SINGLE column,
 * width-constrained to the safe area (with a slightly smaller font), so every move name is
 * fully visible + tappable. Desktop and roomy/landscape screens keep the 2-column grid.
 */
export function moveMenuLayout(opts: {
  safeWidth: number;
  isCompact: boolean;
  isPortrait: boolean;
}): MoveMenuLayout {
  const narrowPhone = opts.isCompact && opts.isPortrait && opts.safeWidth < 520;
  if (!narrowPhone) return { columns: 2 };
  return {
    columns: 1,
    width: Math.min(opts.safeWidth - SPACING.md * 2, 340),
    fontSize: FONT.size.sm,
  };
}
